import React, { useState, useEffect, useRef, useLayoutEffect, Suspense } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { getMembersByPosition, getMembers } from '../service/service';

function SakrebulosTavmjdomarisMoadgileebi() {
	const SakrebuloCard = React.lazy(() => import('./SakrebuloCard') )
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [members, setMembers] = useState({});
	const [pirveliMoadgileebi, setPirveliMoadgileebi] = useState([]);
	const [moadgileebi, setMoadgileebi] = useState([]);
	const [combinedMoadgileebi, setCombinedMoadgileebi] = useState([]);

	useEffect(() => {
		setCombinedMoadgileebi([ ...pirveliMoadgileebi, ...moadgileebi,]);
	}, [moadgileebi, pirveliMoadgileebi]);
	
	

	useEffect(() => {
		const link = `https://khulo.gov.ge/api/members.php?`;
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setMembers(data);
			});
	}, []);

	const [menu, setMenu] = useState({});
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setMenu(data.menu);
				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
					}
				});
			});
	}, []);

	const presscenterList = Object.entries(menu).length
		? Object.entries(menu).map((item, index) => {
				if (item[1].level == 1 && item[1].name_geo == 'საკრებულო') {
					return Object.entries(menu).map((qveItem, index) => {
						if (qveItem[1].parent_id == item[1].cat_id) {
							const windoww = window.location.pathname;
							const result = windoww.split('/').pop();
							const slugg = qveItem[1].slug;
							return (
								<span key={index} className={result === slugg ? 'active' : ''}>
									<Link to={`/${qveItem[1].slug}`}>
										{language == 1 ? qveItem[1].name_geo : qveItem[1].name_eng}
									</Link>
								</span>
							);
						}
					});
				}
		  })
		: 'LOADING';
	const menuName = Object.entries(menu).length
		? Object.entries(menu).find((item, index) => {
				const windoww = window.location.pathname;
				const result = windoww.split('/').pop();
				const slugg = item[1].slug;
				if (result === slugg) {
					return language == 1 ? item[1].name_geo : item[1].name_eng;
				}
		  })
		: '';


	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});

	const membersFc = async position => {
		await getMembersByPosition(position).then(data => {
			setMoadgileebi(data);
		});
	};

	useEffect(() => {
		membersFc('საკრებულოს თავმჯდომარის მოადგილე');
		// membersFc('საკრებულოს თავმჯდომარის პირველი მოადგილე');
	}, []);

	useEffect(() => {
		const memberFc = async () => {
			await getMembers().then(data => {
				const filtered = data.filter(
					member =>
						 member.memberships[0].position_name === 'საკრებულოს თავმჯდომარის პირველი მოადგილე' 
				);
				setPirveliMoadgileebi(filtered);
			});
		};
		memberFc();
	}, []);



	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{' '}
						{language == 1 ? 'საკრებულო' : 'KHULO CITY ASSEMBLY'}
					</span>
					<span>
						{menuName
							? language == 1
								? menuName[1].name_geo
								: menuName[1].name_eng
							: ''}
					</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container moadgileebi--grid'>
							 <Suspense fallback={<h2>Loading...</h2>}>
							{ combinedMoadgileebi?.map((item, index) => (
										<SakrebuloCard
											key={index}
											slug={item?.slug}
											image={item?.image}
											full_name={item?.full_name}
											position={item?.position?.position}
											url={'sakrebulos-tavmjdomaris-pirveli-moadgile'}
										/>
								  ))
								}
								  </Suspense>

						</div>
					</div>
					<div className='presscenter-info'>{presscenterList}</div>
				</div>
			</div>
		</motion.div>
	);
}

export default SakrebulosTavmjdomarisMoadgileebi;
